export default "__FINAL_URL__BI2ADLKB__";